import React, { Component } from "react";
import "./BrandContent.scss";
import { Link } from "react-router-dom";
import BrandlistMenu from "../../../../components/Brands/BrandlistMenu/BrandlistMenu";
import { getArticlesByBrands } from "../../../../api/brands";
import BrandArticlesItem from "../../../../components/Brands/BrandArticlesItem/BrandArticlesItem";
import { getBrandById } from "../../../../api/brands";
import images from "../../../../ressources/images";
import { withTranslation } from "react-i18next";

export class BrandArticles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whoActive: "articles",
      brandId: 0,
      dataArticles: [],
      dataBrand: [],
      lng: this.props.i18n.language,
      loadImage: false,
    };
  }

  UNSAFE_componentWillMount() {
    let brandId = this.props.match.params.brandId;
    this.setState({ brandId: brandId });
  }

  componentDidMount() {
    this.getAllArticlesByBrands();
    this.getBrandByIdFront();
  }

  componentDidUpdate() {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this.getAllArticlesByBrands();
      this.getBrandByIdFront();
    }
  }

  /**
   * Récupere tout les articles disponibles
   */
  getAllArticlesByBrands = () => {
    const { brandId } = this.state;
    this.setState({ dataArticles: [] });
    getArticlesByBrands(brandId).then((data) => {
      this.setState({ dataArticles: data });
    });
  };

  getBrandByIdFront = () => {
    const { brandId } = this.state;
    this.setState({ dataBrand: [] });
    getBrandById(brandId).then((data) => {
      this.setState({ dataBrand: data, loadImage: true });
    });
  };

  render() {
    const { t } = this.props;
    const { dataArticles, dataBrand, brandId, whoActive, loadImage } =
      this.state;
    return (
      <>
        <div className="white--wrapper">
          <Link
            className="brandlist_backlink"
            to={{ pathname: "/brands", state: { transitionName: "slide_out" } }}
          >
            <img src={images.arrow_left_black} alt="" />
          </Link>
          <div className="brandlist_content default-layout--min-height flex flex-col">
            <div className="flex-row-center">
              <div className="brand_logo">
                {loadImage && (
                  <img
                    className="brandlist_logo"
                    src={dataBrand.logoNoir}
                    alt="logo"
                  />
                )}
              </div>
            </div>
            <BrandlistMenu whoActive={whoActive} brandId={brandId} />
            <div className="brand_contentlist">
              {dataArticles.length > 0 ? (
                dataArticles.map((article) => (
                  <BrandArticlesItem
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    subtitle={article.subtitle}
                    picture={article.picture}
                    content={article.content}
                    brandId={brandId}
                  />
                ))
              ) : (
                <div className="back_soon">
                  <div>{t("freelance_missing")}</div>
                  <div>{t("come_back_soon")} </div>
                  <span className="smile" role="img" aria-label="">
                    &#128578;
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(BrandArticles);
